// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2oJFw","sendOtp":"AuthorizeToLogin_sendOtp__3sFCT"};